import { render, staticRenderFns } from "./MountainIcon.vue?vue&type=template&id=0d0ba6ce"
import script from "./MountainIcon.vue?vue&type=script&lang=js"
export * from "./MountainIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports